import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import styled from 'styled-components'

import { fullAnimate } from '@/components/Modal'

import { stepAnimate } from '..'
import contentVoiceImg from '../images/content-voice.gif'

interface IProps {
  rtcEngine: any
  next: (stepActive: number, status?: boolean) => void
}

export default ({ rtcEngine, next }: IProps) => {
  const [isBtn, setisBtn] = useState<boolean>(true)

  const handleAsk = () => {
    setisBtn((v) => !v)
  }

  const handleNext = (status: boolean) => {
    next(1, status)
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      <div className="base-img" />
      {/* <div className="base-tips" /> */}
      {isBtn ? <div className="base-title">能听到声音吗？</div> : null}
      {isBtn ? (
        <div className="btns">
          <div className="btn-ask anim_btn2" onClick={handleAsk}>
            ?
          </div>
          <div className="base-btn yes anim_btn2" onClick={() => handleNext(true)}>
            能听到声音
          </div>
          <div className="base-btn no anim_btn2" onClick={() => handleNext(false)}>
            听不到声音
          </div>
        </div>
      ) : null}
      <AnimatePresence>
        {!isBtn ? (
          <motion.div {...fullAnimate} className="ask">
            <div>
              <div>如果你听不到声音，请按以下方式排查问题：</div>
              <div>1.请调大设备音量</div>
              <div>2.确认没有耳机等外接设备接入</div>
            </div>
            <div className="yes-ask anim_btn2" onClick={handleAsk}>
              知道了
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </Container>
  )
}

const Container = styled(motion.div)`
  .base-img {
    background-image: url('${contentVoiceImg}');
  }
  .btns {
    width: 100%;
    position: relative;
    /* padding: 0 90px; */
    display: flex;
    // justify-content: space-around;
    justify-content: center;
  }
  .ask {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    line-height: 20px;
    font-size: 14px;
    // width: 750px;
    height: 115px;
    background: rgba(255, 241, 229, 1);
    border-radius: 0px 0px 25px 25px;
    display: flex;
    justify-content: space-between;
    // align-items: flex-end;
    padding: 30px 25px;
    box-sizing: border-box;
    color: rgba(255, 120, 0, 1);
    box-shadow: 0 4px 8px 4px #dcdcdc;
  }
  .yes-ask {
    text-decoration: underline;
    cursor: pointer;
  }
  .btn-ask {
    width: 45px;
    height: 45px;
    background: rgba(255, 120, 0, 0.1);
    border-radius: 28px;
    font-size: 25px;
    font-weight: 500;
    color: rgba(255, 120, 0, 1);
    text-align: center;
    line-height: 45px;
    position: absolute;
    left: -40px;
  }
  .yes {
    // background: linear-gradient(180deg, rgba(14, 198, 69, 1) 0%, rgba(16, 214, 75, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(13, 158, 56, 1);
    background: #0bc442;
    box-shadow: 0px 4px 0px 0px #0d9e38;
  }
  .no {
    // background: linear-gradient(180deg, rgba(243, 8, 8, 1) 0%, rgba(255, 65, 65, 1) 100%);
    // box-shadow: 0px 3px 0px 0px rgba(207, 11, 11, 1);
    background: #ff5050;
    box-shadow: 0px 3px 0px 0px #d1385f;
  }
`
